import React, { useEffect, useState } from 'react';
import { Grid } from 'components/layout/Grid';
import { Brikk } from 'components/Brikk';
import { IntlPageTitle } from 'components/intl/IntlPageTitle';
import { ModalIntro } from 'components/layout/ModalIntro';
import userAdminSrc from 'assets/media/user-admin.png';
// import { ProceedButton } from 'components/form-elements/buttons/ProceedButton';
import { GET_USER_IN_2N } from 'services/2n/get-user';
import { useQueryClient } from 'react-query';
// import styles from './styles.module.scss';
import { useUserPermissionsByEmail } from 'services/user/permissions/permissions-by-email';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { ShouldRender } from '../../../../../ShouldRender';
import { ACTIVE_TAB } from './constants';
import { UsersList } from './components/Users/components/UsersList';
import { UserForm } from './components/User/components/UserForm';
import { AddUserForm } from './components/User/components/AddUserForm';
import { ManageService } from './components/ManageService';
import { UserAdministrationModalContext } from './UserAdministrationModalContext';

export const UserAdministrationModal = () => {

  const [activeTab, setActiveTab] = useState(ACTIVE_TAB);
  const [invitedUser, setInvitedUser] = React.useState(null);

  const [selectedUser, setSelectedUser] = useState(null);
  const [service, setService] = useState(null);

  const { checkPermissionsByEmail } = useUserPermissionsByEmail(selectedUser?.email);
  const canReadPrimaryResidentAddress = checkPermissionsByEmail('admin-address', 'read');

  const [isPrimaryResidentAddress, setIsPrimaryResidentAddress] = useState(false);
  const [isAddingUser, setIsAddingUser] = useState(false);
  const queryClient = useQueryClient();
  const tenantId = getTenantIDBasedOnURL();
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  useEffect(() => {
    if (selectedUser) {
      setIsPrimaryResidentAddress(!!canReadPrimaryResidentAddress);
      queryClient.invalidateQueries([GET_USER_IN_2N, tenantId, selectedUser.email]);
    }
  }, [selectedUser, canReadPrimaryResidentAddress]);

  return (
    <UserAdministrationModalContext.Provider
      value={{
        selectedUser,
        setSelectedUser,
        service,
        setService,
        isAddingUser,
        setIsAddingUser,
        isPrimaryResidentAddress,
        setIsPrimaryResidentAddress,
        activeTab,
        setActiveTab,
        invitedUser,
        setInvitedUser,
        hasUnsavedChanges,
        setHasUnsavedChanges,
      }}
    >
      <Grid brikkLayout>
        <IntlPageTitle intlTitle="userAdminBrikk" />

        <Grid.Column>
          <Brikk.Heading
            main
            heading="userAdminBrikk"
          >
            <ModalIntro>
              <ModalIntro.Image
                src={userAdminSrc}
                alt="User admin"
              />

              <ModalIntro.Text intl="userAdminDescription" />
            </ModalIntro>
          </Brikk.Heading>
            
          {/* <ProceedButton className={styles.button}>
            <ProceedButton.Button
              size={14}
              intl="goToDocuments"
            />
            <ProceedButton.SignIn />
          </ProceedButton> */}
       
        </Grid.Column>
        
        <Grid.Column>
          <UsersList />
        </Grid.Column>

        <ShouldRender condition={!service && !isAddingUser}>
          <Grid.Column noOverflow>
            <UserForm />
          </Grid.Column>
        </ShouldRender>

        <ShouldRender condition={!service && isAddingUser}>
          <Grid.Column noOverflow>
            <AddUserForm />
          </Grid.Column>
        </ShouldRender>

        <ShouldRender condition={service}>
          <Grid.Column>
            <ManageService />
          </Grid.Column>  
        </ShouldRender>
      </Grid>
    </UserAdministrationModalContext.Provider>
  );
};
